import { render, staticRenderFns } from "./LoginText.vue?vue&type=template&id=74d5bb10&scoped=true"
import script from "./LoginText.vue?vue&type=script&lang=ts"
export * from "./LoginText.vue?vue&type=script&lang=ts"
import style0 from "./LoginText.vue?vue&type=style&index=0&id=74d5bb10&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d5bb10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74d5bb10')) {
      api.createRecord('74d5bb10', component.options)
    } else {
      api.reload('74d5bb10', component.options)
    }
    module.hot.accept("./LoginText.vue?vue&type=template&id=74d5bb10&scoped=true", function () {
      api.rerender('74d5bb10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/login/LoginText.vue"
export default component.exports